/* Hero.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _21 = "@media (min-width:48rem){._6o24cs5v{order:2}}";
const _20 = "._1f49kb7n{order:1}";
const _19 = "._i0dlf1ug{flex-basis:0%}";
const _18 = "._1o9zkb7n{flex-shrink:1}";
const _17 = "._16jlkb7n{flex-grow:1}";
const _16 = "@media (min-width:48rem){._6o24kb7n{order:1}}";
const _15 = "._1f49cs5v{order:2}";
const _14 = "._i0dl1osr{flex-basis:62%}";
const _13 = "._1o9zidpf{flex-shrink:0}";
const _12 = "._16jlidpf{flex-grow:0}";
const _11 = "@media (min-width:64rem){._dbjgidpf{margin-top:0}._1hvk1kvb{margin-right:8.5%}._isu4idpf{margin-bottom:0}._15qm1kvb{margin-left:8.5%}._pdlmhiv4{gap:var(--ds-space-400)}}";
const _10 = "@media (min-width:48rem){._1lp7vrvc{flex-direction:row}}";
const _9 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _8 = "._4cvr1h6o{align-items:center}";
const _7 = "._2lx21bp4{flex-direction:column}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _4 = "._19pk1eps{margin-top:var(--ds-space-100)}";
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, FluidContainer, H1 } from '@atlassian/mpac-primitives';
import { SearchEmbedded } from '@atlassian/mpac-search';
import React from 'react';
import HeroImage from '../../assets/hero.svg';

// @TODO: Replace hex values with theme variables once they are available - https://ecosystem.atlassian.net/browse/MC-4749
const _3 = "._1yt4a4w1{padding:var(--ds-space-500) 0}";
const _2 = "._bfhk1t97{background-color:#e9f2fe}";
const _ = "._1bsb1osq{width:100%}";
const HeroWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _bfhk1t97 _1yt4a4w1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroWrapper.displayName = 'HeroWrapper';
}
const Description = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1eps _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const HeroInner = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_6, _7, _8, _9, _10, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o _zulpl6l0 _1lp7vrvc _dbjgidpf _1hvk1kvb _isu4idpf _15qm1kvb _pdlmhiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeroInner.displayName = 'HeroInner';
}
const ContentContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_12, _13, _14, _15, _16]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_16jlidpf _1o9zidpf _i0dl1osr _1f49cs5v _6o24kb7n", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ContentContainer.displayName = 'ContentContainer';
}
const ImageContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_17, _18, _19, _20, _21]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1f49kb7n _6o24cs5v", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const Image = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
export const Hero = () => {
  return /*#__PURE__*/React.createElement(HeroWrapper, null, /*#__PURE__*/React.createElement(FluidContainer, null, /*#__PURE__*/React.createElement(HeroInner, null, /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(H1, null, "Boost your Atlassian experience"), /*#__PURE__*/React.createElement(Description, null, "with 5000+ diverse apps & integrations")), /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(Image, {
    src: HeroImage
  }))), /*#__PURE__*/React.createElement(SearchEmbedded, {
    inputWidth: 460
  })));
};